export default function(api: GlobalFetch) {
  return async function() {
    const subs = await api.fetch(`/api/v2/license/sub`)

    return await handleResponse(subs)
  }
}

export async function handleResponse(response) {
  const json = await response.json()
  return json.items
}
